<template>
	<catalog-picker-component 
		ref="c" 
		auth 
		:size="size"
		v-model="selectedCustomer"
		:placeholder="searchPlaceholder ?? 'Поиск контрагентов по инициалам, названию компании, телефону или email'"
		:catalog-tab="counterpartiesCatalogTab" 
		search-url="/api/counterparties/search" 
		@update:modelValue="emitUpdate"
		:search-parameters="{ types: counterpartyType }"
		@catalog-item-picked="onCustomerPickedFromCatalog">
		<template #empty>
			Подрядчиков по запросу не найдено ☹️
		</template>
		<template #default="scope">
			<span style="float: left">{{ `${scope.lastname} ${scope.firstname} ${scope.middlename ?? ''}` }}</span>
			<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">{{ scope.phone }}</span>
		</template>
		<template #label>
			<span style="float: left">
				{{ `${selectedCustomer!.lastname} ${selectedCustomer!.firstname} ${selectedCustomer!.middlename ?? ''}` }}
			</span>
			<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">
				{{ selectedCustomer!.phone }}
			</span>
		</template>
	</catalog-picker-component>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Delete, Edit, Plus, Search } from '@element-plus/icons-vue';
import CatalogPickerComponent from '@/components/CatalogPickerComponent.vue';
import CounterpartyModel from '@/models/CounterpartyModel';
import TabsDictionary from '@/variables/tabs';

@Options({
	components: {		
		CatalogPickerComponent
	},
	props: {	
		size: {
			type: String,
			default: null
		},
		modelValue: {
			type: Object,
			default: null
		},
		searchPlaceholder: {
			type: String,
			default: null
		},
		counterpartyType: {
			type: Number,
			require: true
		}
	},
	emits: ['update:modelValue']
})
export default class CounterpartyPickerComponent extends Vue {
	/** props */
	size!: String;
	modelValue!: CounterpartyModel | null;
	searchPlaceholder!: string;
	counterpartyType!: number;

	/** constants */
	searchIcon = Search;
	deleteIcon = Delete;
	editIcon = Edit;
	plusIcon = Plus;
	counterpartiesCatalogTab = TabsDictionary.counterparties;

	/** view-models */
	selectedCustomer: CounterpartyModel | null = null;

	mounted() {
		if (this.modelValue?.id) {
			const onCounterpartyComponent = this.$refs.c as any;
			this.selectedCustomer = {...this.modelValue};
			onCounterpartyComponent?.set(this.selectedCustomer);
		}
	}

	emitUpdate() {
		this.$emit('update:modelValue', this.selectedCustomer);
	}

	onCustomerPickedFromCatalog(counterparty: CounterpartyModel | null) {
		const onCounterpartyComponent = this.$refs.c as any;
		onCounterpartyComponent?.set(counterparty);
		this.emitUpdate();
	}

	/** exposed function */
	clear() {
		const catalogPickerComponent = (this.$refs.c as CatalogPickerComponent);
		catalogPickerComponent.set(null);
	}

	/** exposed function */
	set(counterpartyModel?: CounterpartyModel) {
		const catalogPickerComponent = (this.$refs.c as CatalogPickerComponent);

		if (!counterpartyModel?.id) {
			catalogPickerComponent.set(null);
		} else {
			catalogPickerComponent.set(counterpartyModel);
		}
	}
}
</script>